import React, { FC } from 'react'
import Svg, { SvgProps } from '..'

interface SyzygyLogoProps extends SvgProps {
  width?: string
  height?: string
  stripeFill?: string
}

const SyzygyLogo: FC<SyzygyLogoProps> = ({
  className,
  style,
  width,
  height,
  stripeFill,
  ...props
}) => {
  const stripeStyle = stripeFill ? { fill: stripeFill } : undefined

  return (
    <Svg
      viewBox="0 0 792 200"
      className={['syzygy-logo-svg', className].filter(Boolean).join(' ')}
      style={style}
      width={width}
      height={height}
      {...props}
    >
      <g opacity=".99">
        <path d="M183.01,171.81v-60.45h14.22v60.45h-14.22Z" />
        <path d="M251.88,172.39l-30.56-45.36h-.58v44.78h-7.06v-59.68l13.83-1.26,29.4,43.62h.58v-43.14h6.96v59.77l-12.57,1.26Z" />
        <path d="M294.34,171.81v-53.68c-10.16.29-14.41,1.16-19.44,3.09v-9.87h52.91v9.87c-4.84-1.93-9.48-2.8-19.25-3.09v53.68h-14.22Z" />
        <path d="M338.26,171.81v-60.45h41.78v9.77c-4.74-1.94-9.19-2.9-19.63-2.9h-7.93v19.83h19.44v6.48h-19.44v20.41h7.93c10.45,0,14.9-.97,19.63-2.9v9.77h-41.78Z" />
        <path d="M428.7,171.81l-13.93-24.95-6-.29v25.24h-14.22v-60.35l23.31-.39c16.25-.29,23.79,6.19,23.79,15.96,0,7.45-4.84,14.02-12.96,16.64l16.64,28.15h-16.64ZM408.77,117.74v22.15c1.45.19,3.97.39,5.8.39,7.06,0,11.8-4.35,11.8-11.12,0-7.16-4.26-11.41-12.96-11.41h-4.64Z" />
        <path d="M492.34,171.81l-5.8-17.02h-21.86l-5.9,17.02h-7.45l19.44-54.55v-4.06l15.09-3.38,21.67,62h-15.19ZM476.38,123.55h-.97l-8.51,24.95h17.51l-8.03-24.95Z" />
        <path d="M568.47,166.88c-6,4.35-13.54,6.38-21.47,6.38-20.31,0-33.95-11.22-33.95-30.95s14.12-32.4,33.85-32.4c9.48,0,16.83,2.22,23.41,6.09l-4.45,8.9c-4.74-4.84-10.45-8.51-18.18-8.51-11.03,0-19.34,8.61-19.34,24.47,0,17.02,8.22,25.83,20.6,25.83,5.51,0,11.22-1.45,16.15-5.61l3.39,5.8Z" />
        <path d="M596.32,171.81v-53.68c-10.16.29-14.41,1.16-19.44,3.09v-9.87h52.91v9.87c-4.84-1.93-9.48-2.8-19.25-3.09v53.68h-14.22Z" />
        <path d="M640.24,171.81v-60.45h14.22v60.45h-14.22Z" />
        <path d="M687.15,172.1l-21.28-60.74h15.19l16.25,48.07h.87l17.22-48.07h7.35l-22.34,60.74h-13.25Z" />
        <path d="M734.16,171.81v-60.45h41.78v9.77c-4.74-1.94-9.19-2.9-19.64-2.9h-7.93v19.83h19.44v6.48h-19.44v20.41h7.93c10.45,0,14.9-.97,19.64-2.9v9.77h-41.78Z" />
      </g>

      <g>
        <circle cx="86.47" cy="103.45" r="72.55" />
        <g>
          <polygon
            className="syzygy-logo__stripe"
            style={stripeStyle}
            points="55.55 134.58 47.96 134.57 78.54 72.33 86.13 72.33 55.55 134.58"
          />
          <polygon
            className="syzygy-logo__stripe"
            style={stripeStyle}
            points="74.97 134.58 67.39 134.57 97.96 72.33 105.55 72.33 74.97 134.58"
          />
          <polygon
            className="syzygy-logo__stripe"
            style={stripeStyle}
            points="94.4 134.58 86.81 134.57 117.39 72.33 124.98 72.33 94.4 134.58"
          />
        </g>
      </g>

      <g>
        <path d="M217.89,89.33l-5.69-17.15h-20.22l-5.69,17.15h-5.87l17.51-51.27v-3.34l11.92-3.43,19.68,58.04h-11.65ZM202.64,42.57h-.81l-8.12,24.64h16.79l-7.85-24.64Z" />
        <path d="M237.39,80.57c2.8,3.16,6.68,5.15,11.55,5.15,5.15,0,8.67-1.9,8.67-5.6,0-3.07-2.35-5.15-9.39-7.4-8.67-2.8-13.81-6.23-13.81-13.54,0-6.77,5.78-12.55,16.25-12.55,5.51,0,10.56,1.17,14.71,3.43l-2.89,6.68c-2.8-3.07-6.86-5.15-11.65-5.15-5.06,0-7.58,1.9-7.58,4.96,0,2.89,1.9,4.69,8.76,7.04,9.93,3.43,14.44,6.77,14.44,13.54,0,7.31-6.05,13.54-17.42,13.54-5.51,0-10.56-1.26-14.53-3.43l2.89-6.68Z" />
        <path d="M276.12,80.57c2.8,3.16,6.68,5.15,11.55,5.15,5.15,0,8.67-1.9,8.67-5.6,0-3.07-2.35-5.15-9.39-7.4-8.67-2.8-13.81-6.23-13.81-13.54,0-6.77,5.78-12.55,16.25-12.55,5.51,0,10.56,1.17,14.71,3.43l-2.89,6.68c-2.8-3.07-6.86-5.15-11.65-5.15-5.06,0-7.58,1.9-7.58,4.96,0,2.89,1.9,4.69,8.76,7.04,9.93,3.43,14.44,6.77,14.44,13.54,0,7.31-6.05,13.54-17.42,13.54-5.51,0-10.56-1.26-14.53-3.43l2.89-6.68Z" />
        <path d="M347.08,85.9c-3.52,2.98-8.03,4.78-14.62,4.78-12.19,0-20.76-8.49-20.76-21.48s8.94-22.57,20.67-22.57,17.33,7.13,17.33,16.97c0,1.17-.09,2.98-.36,4.42h-27.17c0,9.57,4.51,17.42,13.27,17.42,3.52,0,6.68-1.35,9.3-3.61l2.35,4.06ZM339.77,63.42c0-7.22-2.44-11.83-7.76-11.83-4.24,0-8.31,4.42-9.57,11.83h17.33Z" />
        <path d="M384.45,85.54c-3.34,3.34-6.59,5.15-12.1,5.15-7.49,0-11.37-4.15-11.37-13.63v-23.83h-6.59v-5.24h6.59v-11.83l9.66-2.35v14.17h12.64v5.24h-12.64v24.55c0,5.33,1.81,7.04,4.96,7.04,2.44,0,4.42-1.44,6.68-3.7l2.17,4.42Z" />
        <path d="M442.41,89.33l-5.69-17.15h-20.22l-5.69,17.15h-5.87l17.51-51.27v-3.34l11.92-3.43,19.68,58.04h-11.64ZM427.16,42.57h-.81l-8.12,24.64h16.79l-7.85-24.64Z" />
        <path d="M461.46,89.33V28.76l9.66-2.35v62.92h-9.66Z" />
        <path d="M482.86,89.33V28.76l9.66-2.35v62.92h-9.66Z" />
        <path d="M501.55,69.2c0-12.82,8.76-22.57,22.03-22.57s20.58,9.12,20.58,21.49-8.76,22.57-22.03,22.57-20.58-9.12-20.58-21.48ZM533.77,69.83c0-12.55-4.97-18.14-11.28-18.14s-10.56,5.78-10.56,15.89c0,12.46,4.96,18.14,11.19,18.14s10.65-5.87,10.65-15.89Z" />
        <path d="M586.49,85.9c-3.61,2.98-7.94,4.78-14.44,4.78-12.19,0-20.67-8.67-20.67-21.48s8.49-22.57,21.3-22.57c6.32,0,11.28,1.63,15.35,4.78l-3.88,6.32c-2.89-3.7-6.14-6.14-10.83-6.14-7.4,0-11.55,7.13-11.55,17.06s4.6,16.7,13.09,16.7c3.16,0,6.59-1.26,9.21-3.61l2.44,4.15Z" />
        <path d="M617.1,89.33v-5.69h-.36c-2.98,4.42-7.13,7.04-13.18,7.04s-11.19-4.51-11.19-11.1c0-8.58,8.12-12.91,22.48-16.34l2.26-.54v-1.9c0-6.5-1.81-9.12-7.13-9.12-3.79,0-7.94,2.53-11.37,7.31l-3.97-6.05c5.87-4.6,10.74-6.32,17.6-6.32,10.38,0,14.62,5.24,14.62,17.24v25.46h-9.75ZM617.1,67.12l-2.17.63c-9.21,2.71-12.73,6.05-12.73,9.84s2.53,5.96,5.78,5.96c3.79,0,7.04-2.44,9.12-5.42v-11.01Z" />
        <path d="M663.95,85.54c-3.34,3.34-6.59,5.15-12.1,5.15-7.49,0-11.37-4.15-11.37-13.63v-23.83h-6.59v-5.24h6.59v-11.83l9.66-2.35v14.17h12.64v5.24h-12.64v24.55c0,5.33,1.81,7.04,4.97,7.04,2.44,0,4.42-1.44,6.68-3.7l2.17,4.42Z" />
        <path d="M670.09,33.9c0-3.52,2.8-6.32,6.14-6.32s6.14,2.8,6.14,6.32-2.8,6.23-6.14,6.23-6.14-2.8-6.14-6.23ZM671.36,89.33v-40.17l9.75-2.26v42.43h-9.75Z" />
        <path d="M690.22,69.2c0-12.82,8.76-22.57,22.03-22.57s20.58,9.12,20.58,21.49-8.76,22.57-22.03,22.57-20.58-9.12-20.58-21.48ZM722.45,69.83c0-12.55-4.97-18.14-11.28-18.14s-10.56,5.78-10.56,15.89c0,12.46,4.96,18.14,11.19,18.14s10.65-5.87,10.65-15.89Z" />
        <path d="M768.22,89.33v-25.55c0-6.41-2.08-9.21-7.13-9.21-3.52,0-7.22,2.8-9.57,5.78v28.98h-9.66v-40.17l9.66-2.26v6.68h.45c4.51-4.42,9.03-6.95,14.44-6.95,8.12,0,11.55,6.05,11.55,13.72v28.98h-9.75Z" />
      </g>
    </Svg>
  )
}

export default SyzygyLogo
